// extracted by mini-css-extract-plugin
export default {"label":"_be33e1df","link":"_21c37cd9"};